import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../Styles/style.css";
import axios from "axios";
import hireImg1 from "../Asstes/Images/hirepro-img-1.png";

import listIcon from "../Asstes/Images/lists-icon.svg";
import hireImg2 from "../Asstes/Images/hirepro-img-2.png";
import lineImg1 from "../Asstes/Images/line-img-1.png";
import lineImg2 from "../Asstes/Images/line-img-2.png";
import lineImg3 from "../Asstes/Images/line-img-3.png";
import sol1 from "../Asstes/Images/solutions-1.png";
import sol2 from "../Asstes/Images/solutions-2.png";
import sol3 from "../Asstes/Images/solutions-3.png";
import blogImg from "../Asstes/Images/For-Companies-Blog-img.png";
import reviewsImg from "../Asstes/Images/for-companies-reviews-img.png";
// import insightsPlaceholder from '../Asstes/Images/insight-placeholder.png';

const HireOnProSapiens = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [bannerData, setBannerData] = useState(null);
  const [contentData, setContentData] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [insights, setInsights] = useState([]);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  const insightsSliderSettings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  const cards = [
    {
      img: sol1,
      title: "Process",
      desc: "Explore success stories and see how we’ve helped companies grow.",
    },
    {
      img: blogImg,
      title: "Blog",
      desc: "Insights & Resources for Smarter Hiring",
    },
    { img: reviewsImg, title: "Reviews", desc: "Trusted by Leading Companies" },
    {
      img: sol3,
      title: "1% Program",
      desc: "Connect with the top 1% of global talent.",
    },
    {
      img: sol2,
      title: "Remote Program",
      desc: "Build and manage high-performing remote teams.",
    },
  ];

  // Banner
  useEffect(() => {
    AOS.init({ duration: 1000 });
    fetch(
      "/prosapiens-cms/public/api/banners/about-prosapiens"
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.banners?.length > 0) {
          setBannerData(data.banners[0]);
        }
      })
      .catch((err) => console.error("Error fetching banner data:", err));
  }, []);

  // Content
  useEffect(() => {
    axios
      .get(
        "/prosapiens-cms/public/api/content/about-prosapiens"
      )
      .then((res) => {
        if (res.data?.content) {
          const sorted = [...res.data.content].sort(
            (a, b) => Number(a.content_order) - Number(b.content_order)
          );
          setContentData(sorted);
        }
      })
      .catch((err) => console.error("Error fetching content:", err));
  }, []);

  // FAQs from API
  useEffect(() => {
    axios
      .get("/prosapiens-cms/public/api/content/faqs")
      .then((res) => {
        if (res.data?.content) {
          const filtered = res.data.content
            .filter((item) => item.link_url === "hire-about-prosapiens")
            .sort((a, b) => Number(a.content_order) - Number(b.content_order))
            .map((item, index) => ({
              q: `${index + 1}. ${item.content_title}`,
              a: item.content_text.replace(/<\/?[^>]+(>|$)/g, ""),
            }));
          setFaqs(filtered);
        }
      })
      .catch((err) => console.error("Error fetching FAQs:", err));
  }, []);

  // Insights from API
  useEffect(() => {
    axios
      .get("/prosapiens-cms/public/api/images/about-us")
      .then((res) => {
        if (res.data?.images) {
          const formatted = res.data.images.map((img) => ({
            img: img.image_name
              ? `/prosapiens-cms/public/${img.image_name}`
              : null,
            text: img.content_text || "",
          }));
          setInsights(formatted);
        }
      })
      .catch((err) => console.error("Error fetching insights:", err));
  }, []);

  const getContentByOrder = (order) => {
    const found = contentData.find((c) => Number(c.content_order) === order);
    return found || null;
  };

  return (
    <div className="hire-page">
      {/* Banner */}
      <section className="hire-section">
        <div className="container">
          <div className="hire-banner">
            <div className="image-container">
              <div className="text-side about" data-aos="fade-right">
                {bannerData ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: bannerData.content_text,
                    }}
                  />
                ) : (
                  <h2>Loading banner...</h2>
                )}
              </div>
              <div className="image-side-about" data-aos="fade-left">
                {bannerData ? (
                  <img
                    src={`/prosapiens-cms/public/${bannerData.banner_image}`}
                    alt="Hire ProSapiens Banner"
                  />
                ) : (
                  <img src={hireImg1} alt="Loading Banner" />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2 */}
      {getContentByOrder(1) && (
        <section className="feature-row">
          <div
            dangerouslySetInnerHTML={{
              __html: getContentByOrder(1).content_text,
            }}
          />
        </section>
      )}

      {/* Section 3 */}
      <div className="container">
        {getContentByOrder(2) && (
          <div
            dangerouslySetInnerHTML={{
              __html: getContentByOrder(2).content_text,
            }}
          />
        )}
      </div>

      {/* Section 4 */}
      <section className="what-we-do">
        <div className="container">
          <div className="image-container">
            {getContentByOrder(3)?.content_image && (
              <div className="image-side" data-aos="fade-right">
                <img
                  src={`/prosapiens-cms/public/${
                    getContentByOrder(3).content_image
                  }`}
                  alt={getContentByOrder(3)?.content_title || "Office meeting"}
                />
              </div>
            )}
            <div className="text-side" data-aos="fade-left">
              {getContentByOrder(3)?.content_text && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: getContentByOrder(3).content_text,
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Section 5 */}
      <div className="container">
        {getContentByOrder(4) && (
          <div
            dangerouslySetInnerHTML={{
              __html: getContentByOrder(4).content_text,
            }}
          />
        )}
      </div>

      {/* Section 6 */}
      <div className="container">
        {getContentByOrder(5) && (
          <div
            dangerouslySetInnerHTML={{
              __html: getContentByOrder(5).content_text,
            }}
          />
        )}
      </div>

      {/* Solutions Slider */}
      <section className="hire-slider">
        <div className="container">
          <h1 data-aos="fade-up">Explore Our Solutions</h1>
          <p data-aos="fade-up">
            Discover how ProSapiens empowers companies with innovative hiring
            solutions.
          </p>
          <div className="owl-carousel owl-theme">
            <Slider {...settings}>
              {cards.map((card, i) => (
                <article className="article-card" key={i} data-aos="fade-up">
                  <div className="card-content">
                    <div className="card-image">
                      <img src={card.img} alt={card.title} />
                    </div>
                    <p className="card-title">{card.title}</p>
                    <h3 className="card-description">{card.desc}</h3>
                  </div>
                </article>
              ))}
            </Slider>
          </div>
        </div>
      </section>

      {/* Insights Slider
      <section className="about-slider">
        <div className="container">
          <h1>Explore our insights</h1>
          <div className="owl-carousel owl-theme">
            <Slider {...insightsSliderSettings}>
              {insights.map((item, index) => (
                <article className="article-card" key={index}>
                  <div className="card-content">
                    <div className="card-image">
                      <img src={item.img} alt="Insight" />
                    </div>
                    <div
                      className="article-excerpt-p"
                      dangerouslySetInnerHTML={{ __html: item.text }}
                    />
                  </div>
                </article>
              ))}
            </Slider>
          </div>
        </div>
      </section> */}

      {/* FAQ */}
      <div className="container">
        <div className="faq-wrapper">
          {/* <div className="faq-left">FAQ -</div> */}
          <div className="faq-right">
            <h2>FAQ</h2>
            {faqs.length > 0 ? (
              faqs.map((faq, idx) => (
                <div className="faq-item" key={idx}>
                  <div
                    className={`faq-question${
                      activeIndex === idx ? " active" : ""
                    }`}
                    onClick={() => toggleFAQ(idx)}
                  >
                    {faq.q}
                    <span className="faq-icon">
                      {activeIndex === idx ? "–" : "+"}
                    </span>
                  </div>
                  <div
                    className={`faq-answer${
                      activeIndex === idx ? " active" : ""
                    }`}
                  >
                    {faq.a}
                  </div>
                </div>
              ))
            ) : (
              <p>No FAQs found for this page.</p>
            )}
          </div>
        </div>
      </div>

      {/* Final CTA */}
      <div className="container">
        <div className="hire-box" data-aos="fade-up">
          <div>
            <div className="tagline">
              Cut time-to-hire by 80% with ProSapiens
            </div>
            <h2>
              Let ProSapiens help you find the right talent <br />
              faster with AI-powered recruitment solutions.
            </h2>
          </div>
          <a href="/contact" className="cta-yellow">
            CONTACT US TODAY →
          </a>
        </div>
      </div>
    </div>
  );
};

export default HireOnProSapiens;
